import { render } from "./info.vue?vue&type=template&id=0f6f5a21&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=0f6f5a21&lang=scss&scoped=true"
import "./info.vue?vue&type=style&index=1&id=0f6f5a21&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6f5a21"]])

export default __exports__